<template>
    <div>
        <h1 class="text-center">Template DoHome</h1>
    </div>
</template>
<script>
export default {
    name: "Default"
};
</script>
